import { put, takeEvery, all, call, select } from "redux-saga/effects";
import { GOOGLE, POLICE, SEARCH } from "../constants/";
import api from "../api/";
const { get, post } = api();

const getCategories = state => state.search.categories;

export const searchCrimesByLocation = function*(action) {
  const { data } = action;

  // Request coordinates from Google
  yield put({ type: SEARCH.req_coords });

  try {
    // Get crime categories for date from state
    const currentCategories = yield select(getCategories);

    // If not present fetch them
    if (!currentCategories[data.date]) {
      const categories = yield call(get, POLICE.categories(data.date));
      yield put({ type: SEARCH.res_categories, categories, date: data.date });
    }
    let criteria;

    // If not location fetch location data from Google
    if (!data.location) {
      const coords = yield call(get, GOOGLE.geo_code(data.address));
      criteria = {
        formattedAddress: coords.results[0].formatted_address,
        ...coords.results[0].geometry.location,
        date: data.date
      };
    } else {
      const addressReadable = yield call(
        get,
        GOOGLE.geo_code(`${data.location.lat},${data.location.lng}`)
      );
      criteria = {
        formattedAddress: addressReadable.results[0].formatted_address,
        ...data.location,
        date: data.date
      };
    }

    // Set location and date to state
    yield put({ type: SEARCH.res_coords, criteria });

    // Get police neighbourhood
    const hood = yield call(
      get,
      POLICE.locate_neighbourhood(criteria.lat, criteria.lng)
    );

    // Get array of coordinates for police boundary
    const boundary = yield call(
      get,
      POLICE.area_boundary(hood.force, hood.neighbourhood)
    );

    // Set boundary into state
    yield put({ type: SEARCH.res_boundary, boundary });

    // Fetch crimes from boundary info and date.
    const crimes = yield call(post, POLICE.crimes_by_hood, {
      poly: boundary
        .map(({ longitude, latitude }) => `${latitude},${longitude}`)
        .join(":"),
      date: criteria.date
    });

    // Set crimes to state! Pow!
    yield put({ type: SEARCH.res_crime_by_location, crimes });
  } catch (error) {
    yield put({ type: SEARCH.err_crime_by_location, error });
  }
};

export const availability = function*() {
  yield put({ type: SEARCH.req_availability });
  try {
    const dates = yield call(get, POLICE.availability);
    yield put({ type: SEARCH.res_availability, dates });
  } catch (error) {
    yield put({ type: SEARCH.err_availability });
  }
};

const watchSearchCrimesByLocation = function*() {
  yield takeEvery(SEARCH.crimes_by_location, searchCrimesByLocation);
};

const watchAvailability = function*() {
  yield takeEvery(SEARCH.availability, availability);
};

export const rootSaga = function*() {
  yield all([watchSearchCrimesByLocation(), watchAvailability()]);
};



// WEBPACK FOOTER //
// ./src/sagas/search.js